module.exports = __webpack_public_path__ + "static/media/myAthinaLogo.ad6924b9.png";